import { render, staticRenderFns } from "./EmailLogDetail.vue?vue&type=template&id=5eab33ad&scoped=true"
import script from "./EmailLogDetail.vue?vue&type=script&lang=js"
export * from "./EmailLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eab33ad",
  null
  
)

export default component.exports